import { TextField } from "@material-ui/core";
import React from "react";
import { regex } from "../../../../../utils/consts";
import FormHelperText from "@material-ui/core/FormHelperText";
import ValidationFormControl from "../../../../styles/materialValidFormControl";

const ProjectIpWhitelistItems = ({
  t,
  trustedIpAddresses,
  setTrustedIpAddresses,
  errors,
  setErrors,
  activeButtonSubmit
}) => {

  const handleChange = (event, ipAddressKey) => {
    event.persist();

    const value = event.target.value;

    setErrors(current => {
      const copy = { ...current };
      delete copy[ipAddressKey];
      return copy;
    });

    validateIp(value, ipAddressKey);

    const newTrustedIpAddresses = [...trustedIpAddresses];
    newTrustedIpAddresses[ipAddressKey].value = value;
    setTrustedIpAddresses(newTrustedIpAddresses);
  };

  const validateIp = (value, ipAddressKey) => {
    if (trustedIpAddresses.find(item => item.value === value)) {
      setErrors(current => ({
        ...current,
        [ipAddressKey]: { value: "details.ipWhitelist.errors.ipAlreadyExists" }
      }));
    }

    if (value === "" || (!regex.IP_V4_ADDRESSES.test(value) && !regex.IP_V6_ADDRESSES.test(value))) {
      setErrors(current => ({
        ...current,
        [ipAddressKey]: { value: "details.ipWhitelist.errors.invalidIp" }
      }));
    }
  };

  const handleRemove = (ipAddressKey) => {
    const newTrustedIpAddresses = [...trustedIpAddresses];
    newTrustedIpAddresses.splice(ipAddressKey, 1);
    setTrustedIpAddresses(newTrustedIpAddresses);

    setErrors(current => {
      const copy = { ...current };
      delete copy[ipAddressKey];
      return copy;
    });
  };

  return (
    trustedIpAddresses.map((value, key) => (
      <div key={key} className="projects-ip-list__item">
        <ValidationFormControl error={errors?.[key]?.value && true}>
          <TextField
            label={`IP-${key + 1}`}
            className="grid-form__input"
            type="text"
            value={value.value}
            variant="filled"
            onChange={(event) => handleChange(event, key)}
          />
          {errors && errors[key] && (
            <FormHelperText>
              {t(errors[key].value)}
            </FormHelperText>
          )}
        </ValidationFormControl>
        <button
          className="projects-ip-list__remove"
          title={t("details.ipWhitelist.remove")}
          onClick={() => handleRemove(key)}
          disabled={!activeButtonSubmit && !errors[key]}
        >
          <span className="icon-light-trash" />
        </button>
      </div>
    ))
  );
};

export default ProjectIpWhitelistItems;